import * as tileContentKeys from "../enums/tileContentKeys";
import * as timelineChartTypes from "../enums/timelineChartTypes";

export default function getEmptyTimelineChartContent() {
	return {
		[tileContentKeys.HIDDEN_CATEGORIES]: {},
		[tileContentKeys.CHART_TYPE]: timelineChartTypes.CALENDAR_DAYS,
		[tileContentKeys.VISIBLE_DATASETS]: {},
		[tileContentKeys.TOOLTIPS]: {
			[timelineChartTypes.CALENDAR_DAYS]: [],
			[timelineChartTypes.DAYS_FROM_FILING]: [],
		},
	};
}
